/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Combo_Invalid_ItemsInputs */

const vi_error_combo_invalid_items = /** @type {(inputs: Error_Combo_Invalid_ItemsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mỗi dòng công thức cần chọn thành phần và nhập số lượng lớn hơn 0.`)
};

/**

* @param {Error_Combo_Invalid_ItemsInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_combo_invalid_items = /** @type {((inputs?: Error_Combo_Invalid_ItemsInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Combo_Invalid_ItemsInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_combo_invalid_items(inputs)
});